var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ftue-loading",class:{
    'ftue-loading-small': _vm.size === 'small',
    'ftue-loading-default': _vm.size === 'default'
  }},[_c('span',{staticClass:"ftue-loading-dot"}),_vm._v(" "),_c('span',{staticClass:"ftue-loading-dot"}),_vm._v(" "),_c('span',{staticClass:"ftue-loading-dot"})])}
var staticRenderFns = []
export { render, staticRenderFns }